import { Box, IconButton } from "@mui/material";
import { isFunction } from "lodash-es";
import { OptionsObject, SnackbarKey, SnackbarMessage, useSnackbar } from "notistack";

import AppIcon from "../components/Icons/AppIcon";

function useAppSnackbar() {
  const { enqueueSnackbar: notistackEnqueueSnackbar, closeSnackbar } = useSnackbar();

  const defaultAction = (key: SnackbarKey) => (
    // NB: there is a weird bug that custom components receive default MUI theme with missing custom extensions.
    // I suppose it's due to notistack is out of MUI theme context.
    // Workaround: use default MUI components for now.
    <IconButton onClick={() => closeSnackbar(key)}>
      {/* t.palette.primary.contrastText because notistack use #fffff for message */}
      <AppIcon sx={{ fill: (t) => t.palette.primary.contrastText }} of='close' />
    </IconButton>
  );
  const enqueueSnackbar = (message: SnackbarMessage, options: OptionsObject = {}) => {
    const action = options.action
      ? (key: SnackbarKey) => (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {isFunction(options.action) ? options.action(key) : options.action}
            {defaultAction(key)}
          </Box>
        )
      : defaultAction;

    notistackEnqueueSnackbar(message, {
      ...options,
      action,
    });
  };

  return { enqueueSnackbar };
}

export default useAppSnackbar;
